import {
  ICryptoCoin,
  ICryptoPrice,
  COIN_COLOR,
  HISTORY_TYPE,
  COIN_TICKER,
  CURRENCY_FILTER,
  BLOCKCHAINS_NAMES,
  BLOCKCHAINS,
} from './../../../../models/Crypto';
import { MatDialog } from '@angular/material/dialog';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

import * as shape from 'd3-shape';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { Utils } from 'src/app/pages/core/utils/Utils';
import { ConfirmCryptoOrderComponent } from '../../crypto-card/confirm-crypto-order/confirm-crypto-order.component';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { ActivatedRoute, Router } from '@angular/router';
import { IOrderStatus } from 'src/app/pages/core/models/Order';
import { CoinInfo } from '../../../../utils/cryptoCoinInfo';
import BigNumber from 'bignumber.js';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoincapData } from 'src/app/pages/core/models/Coincap';
import { CryptoCompareData } from 'src/app/pages/core/models/CryptoCompare';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let fbq: Function;
declare const LightweightCharts;

enum OPERATION_TYPE {
  BUY = 0,
  SELL = 1,
}

@Component({
  selector: 'app-detail-crypto-card',
  templateUrl: './detail-crypto-card.component.html',
  styleUrls: ['./detail-crypto-card.component.scss'],
})
export class DetailCryptoCardComponent implements OnInit {
  crypto: ICryptoCoin;
  prices: ICryptoPrice;
  isArsCurrency: boolean;
  exchangeCardOpened: boolean;
  ordersStatus: IOrderStatus;
  @ViewChild('chartLightWeight', { static: true }) chartLightWeight: ElementRef;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CURRENCY_FILTER = CURRENCY_FILTER;
  cryptoBuyPrice: number;
  cryptoSellPrice: number;
  variation: number;
  cryptoSymbol: string;
  coinBasicInfo: {
    description: string;
    url: string;
    tags: string[];
    nameSearchApi: string;
    creator: string;
    detailUrl: string;
    category: string;
  };
  introCardOpened: boolean;
  selectedPeriod = 'hour';
  legend = false;
  showLabels = false;
  animations = true;
  xAxis = false;
  yAxis = false;
  showYAxisLabel = false;
  showXAxisLabel = false;
  timeline = false;
  curve = shape.curveMonotoneX;
  minMax = {
    min: 0,
    max: 0,
  };
  fiatModified = false;
  history: any[] = [
    {
      name: '',
      series: [],
    },
  ];
  allHistory: ICryptoPrice[] = [];
  allHistoryToday: ICryptoPrice[] = [];

  colorScheme = {
    domain: ['#fff'],
  };
  loading = true;

  operateQuantity: FormControl = new FormControl('');
  amountArs: FormControl = new FormControl('');
  isBuying = true;

  finalAmount = '0';
  finalAmountWithDiscount = 0;
  minOperableAmount = 1;

  creatingOrder = false;

  // Discount
  applyDiscount = false;
  maxDiscountApplicable = 0;
  companyName = '';
  benefitAlreadyApplied = false;

  isBuyingDisabled = false;
  isSellingDisabled = false;
  chart;
  dataVolatilCrypto: CryptoCompareData[] = [];
  assetsCoinCapApi: CoincapData = null;
  isCreateChart = false;
  isLoadingChart = true;
  selectedPercentage = '';
  labelNetworks = '';
  labelRank = '';
  isMobile = false;
  widthChartMobile = null;
  isStable = false;
  isChangeCurrency = false;
  viewChartMobile = false;
  chartOptions;
  tooltipInfo;
  coordinate;
  hiddenTooltip = false;
  sendByEnter: boolean = false;
  @HostListener('document:keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    if (!this.sendByEnter) {
      event.preventDefault();
      this.handleOrder();
    }
  }

  constructor(
    public authService: AuthService,
    public confirmDialog: MatDialog,
    public router: Router,
    private readonly sso: ScrollStrategyOptions,
    private route: ActivatedRoute,
    public cryptoService: CryptoService,
  ) {}

  ngOnInit(): void {
    this.cryptoSymbol = this.route.snapshot.params.ticker;
    this.isArsCurrency = this.cryptoService.currentCurrency === CURRENCY_FILTER.ARS;
    this.getCrypto();
    this.getNetworks();
    this.colorScheme.domain.push(COIN_COLOR[this.cryptoSymbol]);
    this.coinBasicInfo = CoinInfo[this.cryptoSymbol];
    if (window.innerWidth <= 767) {
      this.isMobile = true;
      this.widthChartMobile = (window.innerWidth * 85) / 100;
    }
    // Removed util benefit feature available
    // if (this.authService.loggedUser.companyData.company) {
    //   this.companyName = this.authService.loggedUser.companyData.company;
    // }
  }

  getCrypto() {
    let cryptos;
    let ticker;
    ticker = this.route.snapshot.params.ticker;
    ticker = this.fixNameTicker(ticker);
    if (this.cryptoService.isStableCoin(ticker)) {
      this.cryptoService.stableCryptos.subscribe((res) => {
        this.isStable = true;
        this.isLoadingChart = true;
        if (res) {
          cryptos = res;
          this.crypto = cryptos.find(
            (crypto) => crypto.symbol === ticker + (this.isArsCurrency ? '_ARS' : '_USD'),
          );
          this.setData();
        }
      });
    } else {
      this.cryptoService.volatilCryptos.subscribe((res) => {
        this.isStable = false;
        if (res) {
          cryptos = res;
          this.crypto = cryptos.find(
            (crypto) => crypto.symbol === ticker + (this.isArsCurrency ? '_ARS' : '_USD'),
          );
          this.setData();
        }
      });
    }
  }

  fixNameTicker(ticker: string) {
    let fixTicker = ticker;
    if (fixTicker === 'LUNC') {
      fixTicker = 'LUNA';
    } else if (fixTicker === 'USTC') {
      fixTicker = 'UST';
    } else if (fixTicker === 'LUNA') {
      fixTicker = 'LUNA2';
    }
    return fixTicker;
  }

  setData() {
    if (this.crypto) {
      this.setCryptoPriceByCoin();
      this.setHistoryByCoin();
      this.setOrderStatus();
      if (this.cryptoSymbol !== 'NUARS' && !this.isStable && !this.isChangeCurrency)
        this.getDataForVolatilChart('hour', '672', 'hour');
      this.getRankCrypto();
    }
  }

  setHistoryByCoin() {
    let data = combineLatest([
      this.cryptoService.getHistoryByCoin(this.crypto.symbol, HISTORY_TYPE.DAILY),
      this.cryptoService.getHistoryByCoin(this.crypto.symbol, HISTORY_TYPE.QUARTERLY),
    ]).pipe(map(([daily, quarterly]) => ({ daily, quarterly })));
    data.subscribe({
      next: ({ daily, quarterly }) => {
        this.allHistoryToday = quarterly;
        this.allHistory = daily;
        this.colorScheme.domain = ['#fff', '#F4B731'];
        if (this.cryptoSymbol === 'NUARS' || this.isStable) {
          this.isLoadingChart = false;
          this.updatePeriodChart(this.selectedPeriod);
        }
        this.loading = false;
      },
    });
    this.maxDiscountApplicable = this.authService.getMaxAplicableDiscount();
    this.coinBasicInfo = CoinInfo[this.cryptoSymbol];
  }

  setCryptoPriceByCoin() {
    this.cryptoService.getCryptoPriceByCoin(this.crypto.symbol).subscribe((coinPrice) => {
      this.prices = coinPrice;
      this.cryptoBuyPrice = +coinPrice.buy;
      this.cryptoSellPrice = +coinPrice.sell;
      this.variation = +coinPrice.variation?.daily;
      this.syncAmounts(false);
      this.loading = false;
    });
  }

  setOrderStatus() {
    this.cryptoService.getOrdersStatus().subscribe((res) => {
      this.ordersStatus = res;
      this.checkOrderStatus();
    });
  }

  closeExchangeForm() {
    this.router.navigateByUrl(`/crypto-exchange`);
  }

  checkOrderStatus() {
    this.isBuyingDisabled = false;
    this.isSellingDisabled = false;

    if (
      ['LUNC', 'USTC', 'LUNA', 'NUARS'].includes(this.cryptoSymbol) ||
      this.ordersStatus.BUY.coins.includes(this.crypto.symbol) ||
      this.cryptoService.checkIsCryptoBundles(this.cryptoSymbol)
    ) {
      this.isBuyingDisabled = true;
      this.isBuying = false;
    }

    if (this.ordersStatus.SELL.coins.includes(this.crypto.symbol)) {
      this.isSellingDisabled = true;
      this.isBuying = true;
    }
  }

  getCryptoPrice(type: number) {
    return type === 0 ? this.cryptoBuyPrice : this.cryptoSellPrice;
  }

  getNetworks() {
    this.cryptoService.getBlockchainStatus().subscribe((resp) => {
      let networks = [];
      resp.forEach((network) => {
        if (network.type === 1) {
          if (network.coins[this.cryptoSymbol]) {
            networks.push(BLOCKCHAINS_NAMES[BLOCKCHAINS[network.chain]]);
          }
        }
      });
      this.labelNetworks = networks.join(', ');
    });
  }

  getDataForVolatilChart(period: string, limit: string, selectedPeriod?: string) {
    this.isLoadingChart = true;
    this.selectedPeriod = selectedPeriod;
    this.cryptoService
      .getDataFromCryptoCompare(this.cryptoSymbol, period, limit)
      .subscribe((data) => {
        this.isLoadingChart = false;
        this.dataVolatilCrypto = data;
        this.createChart();
        this.isCreateChart = true;
      });
  }

  getRankCrypto() {
    if (this.cryptoSymbol !== 'NUARS' && this.coinBasicInfo.nameSearchApi) {
      this.cryptoService.getRankFromCoincap(this.coinBasicInfo.nameSearchApi).subscribe((data) => {
        this.assetsCoinCapApi = data;
      });
    } else {
      this.labelRank = '-';
    }
  }

  createChart(histories?: any) {
    let data = [];
    if (this.isCreateChart) {
      this.chart.remove();
    }

    histories?.reverse(); // El orden del timestamp tiene que ser ASC
    histories?.forEach((historie) => {
      let formatData = {
        value: this.isBuying ? parseFloat(historie.buy) : parseFloat(historie.sell),
        time: Utils.fixTimestampDate(parseInt(historie.timestamp), this.selectedPeriod),
      };
      data.push(formatData);
    });

    if (this.isStable) {
      this.colorScheme.domain[0] = COIN_COLOR[this.crypto.ticker];
      this.chartOptions = {
        width: this.isMobile ? this.widthChartMobile : 605,
        height: this.isMobile ? 231 : 330,
        layout: {
          textColor: '#d1d4dc',
          background: { type: 'light', color: '#1F1D2C' },
        },
        timeScale: { timeVisible: true, secondsVisible: false, borderColor: '#485c7b' },
        grid: {
          vertLines: {
            color: '#3c3c3c',
          },
          horzLines: {
            color: '#3c3c3c',
          },
        },
      };
    } else {
      this.chartOptions = {
        width: this.isMobile ? this.widthChartMobile : 605,
        height: this.isMobile ? 231 : 330,
        layout: {
          background: { color: '#1F1D2C' },
          textColor: '#d1d4dc',
        },
        grid: {
          vertLines: {
            color: '#3c3c3c',
          },
          horzLines: {
            color: '#3c3c3c',
          },
        },
        crosshair: {
          mode: LightweightCharts.CrosshairMode.Normal,
        },
        rightPriceScale: {
          borderColor: '#485c7b',
        },
        timeScale: {
          borderColor: '#485c7b',
          timeVisible: true,
          secondsVisible: false,
        },
      };
    }

    this.chart = LightweightCharts.createChart(
      this.chartLightWeight.nativeElement,
      this.chartOptions,
    );

    let bottomColor = {
      DAI: '244, 183, 49',
      USDT: '38, 161, 123',
      BUSD: '244, 183, 49',
      USDC: '39, 117, 201',
    };

    const areaSeries = this.chart.addSeries(LightweightCharts.AreaSeries, {
      lineColor: this.colorScheme.domain[0],
      topColor: `rgba(${bottomColor[this.crypto.ticker]}, 0.1)`,
      bottomColor: `rgba(${bottomColor[this.crypto.ticker]}, 0.1)`,
      lineWidth: 1.5,
    });
    const candlestickSeries = this.chart.addSeries(LightweightCharts.CandlestickSeries, {
      upColor: '#27AE60',
      downColor: '#EB5757',
      borderUpColor: '#22ab94',
      borderDownColor: '#f7525f',
      wickUpColor: '#22ab94',
      wickDownColor: '#f7525f',
      borderVisible: false,
    });

    if (this.cryptoSymbol === 'NUARS' || this.isStable) {
      areaSeries.setData(data);
      this.chart.timeScale().fitContent();
    } else {
      candlestickSeries.setData(this.dataVolatilCrypto);
    }

    this.chart.subscribeCrosshairMove((param) => {
      if (this.isStable) {
        let dataPoint = param.seriesData.get(areaSeries);
        if (dataPoint) {
          this.tooltipInfo = dataPoint;
          let ejeX = param.point.x + 20;
          this.coordinate = `left: ${ejeX}px; top:${param.point.y}px`;
          this.hiddenTooltip = false;
        } else {
          this.hiddenTooltip = true;
        }
      } else {
        let dataPoint = param.seriesData.get(candlestickSeries);
        if (dataPoint) {
          this.tooltipInfo = dataPoint;
          let ejeX = param.point.x + 20;
          this.coordinate = `left: ${ejeX}px; top:${param.point.y}px`;
          this.hiddenTooltip = false;
        } else {
          this.hiddenTooltip = true;
        }
      }
    });
  }

  updatePeriodChart(selectedPeriod) {
    let days = 30;
    let history = this.allHistory;
    this.selectedPeriod = selectedPeriod;
    if (selectedPeriod === 'hour') {
      history = this.allHistoryToday;
      days = 1;
    } else if (selectedPeriod === 'day') {
      days = 30;
    }
    const currentTime = new Date();
    const selectedTime = new Date(currentTime.getTime() - 1000 * 60 * 60 * 24 * days);
    if (this.cryptoSymbol === 'NUARS' || this.isStable) {
      this.createChart(
        history.filter((cryptoPrice) => {
          return parseInt(cryptoPrice.timestamp, 10) > selectedTime.getTime();
        }),
      );
      this.isCreateChart = true;
    }
  }

  setMaxSrcCoinBalance(percentage: number) {
    if (this.isBuying) {
      let newAmountArs = new BigNumber((this.getAvailableFund() * percentage) / 100);
      this.amountArs.setValue(
        percentage === 100
          ? this.getAvailableFund().toString().replace('.', ',')
          : newAmountArs.toFixed().toString().replace('.', ','),
      );
    } else {
      let newOperateQuantity = new BigNumber(
        (parseFloat(this.getCurrentBalance()) * percentage) / 100,
      );
      this.operateQuantity.setValue(
        this.authService.hasValidatedDNIS()
          ? percentage === 100
            ? this.getCurrentBalance().toString().replace('.', ',')
            : newOperateQuantity.toFixed().toString().replace('.', ',')
          : '0',
      );
    }
    this.syncAmounts(this.isBuying);
    if (this.isBuying) {
      this.selectedPercentage = `${percentage}` + 'b' + (this.isArsCurrency ? '' : 'USD');
    } else {
      this.selectedPercentage = `${percentage}` + 's';
    }
  }

  syncAmounts(amountArsModified) {
    if (amountArsModified) {
      if (!this.amountArs.value || Number(this.amountArs.value) === 0) {
        this.operateQuantity.setValue('0');
        this.finalAmount = '0';
        return;
      }
      this.fiatModified = true;
      this.finalAmount = (this.amountArs.value as string).replace(',', '.');
      let amountArs = new BigNumber(this.finalAmount);
      let buyPrice = new BigNumber(this.getPrice());
      this.operateQuantity.setValue(
        amountArs.dividedBy(buyPrice).toFixed().toString().replace('.', ','),
      );
    } else {
      if (!this.operateQuantity.value || Number(this.operateQuantity.value) === 0) {
        this.amountArs.setValue('0');
        this.finalAmount = '0';
        return;
      }

      this.fiatModified = false;
      let amountCrypto = new BigNumber((this.operateQuantity.value as string).replace(',', '.'));
      let sellPrice = new BigNumber(this.getPrice());
      this.finalAmount = amountCrypto.multipliedBy(sellPrice).toString();
      this.amountArs.setValue(this.finalAmount.replace('.', ','));
    }
  }

  getCurrentBalance(): string {
    let ticker = this.cryptoSymbol;
    if (ticker === 'LUNC') {
      ticker = 'LUNA';
    } else if (ticker === 'USTC') {
      ticker = 'UST';
    } else if (ticker === 'LUNA') {
      ticker = 'LUNA2';
    }
    const balance: { amount: string } = this.authService.loggedUser.balance.crypto[ticker]
      ? this.authService.loggedUser.balance.crypto[ticker]
      : '';

    if (balance) {
      return balance.amount;
    } else {
      return '0';
    }
  }

  getAvailableFund() {
    if (this.authService.hasValidatedDNIS()) {
      if (this.crypto?.currency === 0) {
        return Utils.roundDown(this.authService.loggedUser.balance.fiat.USD);
      } else if (this.crypto?.currency === 1) {
        return Utils.roundDown(this.authService.loggedUser.balance.fiat.ARS);
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  getDiffrenceByDiscount() {
    if (this.operateQuantity.value === '') {
      return '0';
    }

    const operateQuantity = new BigNumber(this.operateQuantity.value as string);

    if (this.isBuying) {
      const cryptoPrice = new BigNumber(this.getCryptoPrice(OPERATION_TYPE.BUY));
      const buyPrice = new BigNumber(this.crypto.buyPrice);
      return buyPrice.minus(cryptoPrice.multipliedBy(operateQuantity)).abs().toString();
    } else {
      const cryptoPrice = new BigNumber(this.getCryptoPrice(OPERATION_TYPE.SELL));
      const sellPrice = new BigNumber(this.crypto.sellPrice);
      return sellPrice.minus(cryptoPrice.multipliedBy(operateQuantity)).abs().toString();
    }
  }

  getFinalAmountWithDiscount(): string {
    if (this.finalAmount === '0') {
      return '0';
    } else if (!this.maxDiscountApplicable) {
      return this.finalAmount;
    } else {
      let finalAmount = new BigNumber(this.finalAmount);
      let differenceDiscount = new BigNumber(this.getDiffrenceByDiscount());

      if (this.isBuying) {
        return finalAmount.minus(differenceDiscount).toString();
      } else {
        return finalAmount.plus(differenceDiscount).toString();
      }
    }
  }

  toggleOperationType(type: string) {
    if (type === 'buy') {
      this.isBuying = true;
      this.syncAmounts(false);
    } else if (type === 'sell') {
      this.isBuying = false;
      this.syncAmounts(false);
    }
    if (this.cryptoSymbol === 'NUARS' || this.isStable) {
      this.updatePeriodChart(this.selectedPeriod);
    }
  }

  openOficialCoinPage() {
    window.open(this.coinBasicInfo.url);
  }

  getPrice() {
    return this.isBuying ? this.prices.buy : this.prices.sell;
  }

  getMinEthOrder() {
    return 5 / this.cryptoService.getByTickerCurr('ETH', 0);
  }

  handleOrder() {
    const fiatCoin = this.crypto.currency === 0 ? 'U$D' : 'AR$';
    const totalAmount: string = this.maxDiscountApplicable
      ? this.getFinalAmountWithDiscount()
      : this.finalAmount;
    const receive = this.isBuying
      ? `${Utils.parseNumberToCurrencyString(this.operateQuantity.value as string)} ${
          this.cryptoSymbol
        }`
      : `${Utils.parseNumberToCurrencyString(totalAmount)} ${fiatCoin}`;
    const total = this.isBuying
      ? `${Utils.parseNumberToCurrencyString(totalAmount)} ${fiatCoin}`
      : `${Utils.parseNumberToCurrencyString(this.operateQuantity.value as string)} ${
          this.cryptoSymbol
        }`;
    const operation: string = this.isBuying ? 'BUY' : 'SELL';
    if (this.validateIfUserOperable()) {
      this.sendByEnter = true;
      this.creatingOrder = true;
      const obs = this.cryptoService.lockMarketOrder(this.crypto.symbol, operation);
      obs.subscribe(
        (res: { price: string; code: string }) => {
          let srcAmount: string = (
            this.isBuying ? totalAmount : (this.operateQuantity.value as string)
          ).replace(',', '.');

          let destAmount: string = (
            this.isBuying ? (this.operateQuantity.value as string) : totalAmount
          ).replace(',', '.');
          const price = new BigNumber(!isNaN(parseFloat(res.price)) ? res.price : this.getPrice());
          if (!this.isBuying) {
            if (this.fiatModified) {
              srcAmount = new BigNumber(destAmount).dividedBy(price).toString();
            } else {
              destAmount = new BigNumber(srcAmount).multipliedBy(price).toString();
            }
          } else {
            if (this.fiatModified) {
              destAmount = new BigNumber(srcAmount).dividedBy(price).toString();
            } else {
              srcAmount = new BigNumber(destAmount).multipliedBy(price).toString();
            }
          }
          this.confirmDialog
            .open(ConfirmCryptoOrderComponent, {
              maxWidth: '100vw',
              panelClass: 'modal-container',
              data: {
                type: this.isBuying,
                receive,
                total,
                price: price,
                symbol: this.cryptoSymbol,
                ticker: this.crypto.symbol,
                currency: this.crypto.currency,
                code: res.code,
                fiatCoin,
                srcCoin: this.isBuying ? fiatCoin : this.cryptoSymbol,
                destCoin: this.isBuying ? this.cryptoSymbol : fiatCoin,
                srcAmount,
                destAmount,
                fiatModified: this.fiatModified,
                firstLockPriceObs: obs,
                options: ['Aceptar'],
              },
            })
            .afterClosed()
            .subscribe(() => {
              this.creatingOrder = false;
              this.sendByEnter = false;
            });
        },
        (err) => {
          if (err.error.internalStatus === 'USER_BLOCKED') {
            this.confirmDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'ERROR AL CREAR LA ORDEN',
                content: `Por motivos de seguridad, su usuario se encuentra bloqueado. Por favor, contáctese con soporte para conocer más detalles.`,
                isError: true,
              },
            });
          } else if (err.error.internalStatus === 'USER_UNKNOWN_IDENTITY') {
            this.confirmDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'ERROR AL CREAR LA ORDEN',
                content: `Por motivos de seguridad, debe subir una selfie para validar su identidad. Por favor, contáctese con soporte para conocer más detalles.`,
                isError: true,
              },
            });
          } else {
            this.confirmDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'ERROR AL CREAR LA ORDEN',
                content: `Ha ocurrido un error al obtener el precio.`,
                isError: true,
              },
            });
          }
          this.creatingOrder = false;
          this.sendByEnter = false;
        },
      );
    } else {
      this.creatingOrder = false;
    }
  }

  validateIfUserOperable() {
    this.sendByEnter = true;
    let maxOperableAmount: number;
    let maxOperableQuantity: BigNumber;
    let price = new BigNumber(this.getPrice());

    if (this.authService.checkOnboardingStatus()) {
      if (this.isBuying) {
        if (this.crypto.currency === 0) {
          maxOperableAmount = Utils.roundDown(this.authService.loggedUser.balance.fiat.USD);
        } else if (this.crypto.currency === 1) {
          maxOperableAmount = Utils.roundDown(this.authService.loggedUser.balance.fiat.ARS);
        }
        maxOperableQuantity = new BigNumber(maxOperableAmount).dividedBy(price);
      } else {
        const cryptoBalance: { amount: string } =
          this.authService.loggedUser.balance.crypto[this.cryptoSymbol];

        maxOperableQuantity = new BigNumber(cryptoBalance?.amount || 0);
        maxOperableAmount = maxOperableQuantity.multipliedBy(price).toNumber();
      }
      const daiPrice: number =
        +this.cryptoService.prices.value[this.crypto.currency ? 'DAI_ARS' : 'DAI_USD'][
          this.isBuying ? 'buy' : 'sell'
        ];

      if (parseFloat(this.getFinalAmountWithDiscount()) / daiPrice < 0.5) {
        const minCurrentCryptoValue = parseFloat(
          (
            (daiPrice * 0.5) /
            (this.isBuying ? this.getCryptoPrice(0) : this.getCryptoPrice(1))
          ).toFixed(4),
        );
        this.confirmDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'ERROR AL CREAR LA ORDEN',
              content: `El monto de la operación no supera el mínimo necesario. (${minCurrentCryptoValue} ${this.cryptoSymbol})`,
              isError: true,
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.sendByEnter = false;
          });
        return false;
      }

      // Validar si el monto a operar es mayor al maximo permitido
      if (this.maxDiscountApplicable) {
        if (
          new BigNumber(this.getFinalAmountWithDiscount()).isGreaterThan(maxOperableAmount) &&
          this.isBuying
        ) {
          this.confirmDialog
            .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'ERROR AL CREAR LA ORDEN',
                content: `No es posible realizar la orden por ${
                  this.crypto.currency === 0 ? 'U$D' : 'AR$'
                } ${Utils.parseNumberToCurrencyString(
                  parseFloat(
                    Utils.parseCurrencryToNumber(this.getFinalAmountWithDiscount()).toFixed(2),
                  ),
                )}
          No tenés fondos suficientes.
          `,
                isError: true,
              },
            })
            .afterClosed()
            .subscribe(() => {
              this.sendByEnter = false;
            });

          return false;
        }
      } else {
        if (new BigNumber(this.finalAmount).isGreaterThan(maxOperableAmount) && this.isBuying) {
          this.confirmDialog
            .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'ERROR AL CREAR LA ORDEN',
                content: `No es posible realizar la orden por ${
                  this.crypto.currency === 0 ? 'U$D' : 'AR$'
                } ${Utils.parseNumberToCurrencyString(
                  parseFloat(Utils.parseCurrencryToNumber(this.finalAmount).toFixed(2)),
                )}
          No tenés fondos suficientes.
          `,
                isError: true,
              },
            })
            .afterClosed()
            .subscribe(() => {
              this.sendByEnter = false;
            });

          return false;
        }
      }

      let operateQuantity = new BigNumber((this.operateQuantity.value as string).replace(',', '.'));
      let currentBalance = new BigNumber(this.getCurrentBalance());
      if (operateQuantity.isGreaterThan(currentBalance) && !this.isBuying) {
        this.confirmDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'ERROR AL CREAR LA ORDEN',
              content: `No es posible realizar la orden por ${Utils.parseNumberToCurrencyString(
                parseFloat(Utils.parseCurrencryToNumber(this.operateQuantity.value).toFixed(2)),
              )} ${this.cryptoSymbol}.
          No tenés fondos suficientes.
          `,
              isError: true,
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.sendByEnter = false;
          });

        return false;
      }
      // Validar si el monto a operar al mínimo permitido
      if (this.cryptoSymbol === 'DAI' && operateQuantity.isLessThan(3)) {
        this.confirmDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'ERROR AL CREAR LA ORDEN',
              content: `No es posible realizar la operación, dado que el monto mínimo es de 5 ${this.cryptoSymbol}`,
              isError: true,
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.sendByEnter = false;
          });

        return false;
      }

      if (this.cryptoSymbol === 'DAI' && !operateQuantity.isGreaterThan(0)) {
        this.confirmDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'ERROR AL CREAR LA ORDEN',
              content: `No es posible realizar la operación, dado que el monto mínimo es de 5 ${this.cryptoSymbol}`,
              isError: true,
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.sendByEnter = false;
          });

        return false;
      }

      if (this.cryptoSymbol === 'ETH' && operateQuantity.isLessThan(0)) {
        this.confirmDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'ERROR AL CREAR LA ORDEN',
              content: `No es posible realizar la operación, dado que el monto debe ser mayor a 0`,
              isError: true,
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.sendByEnter = false;
          });

        return false;
      }

      return true;
    } else {
      return false;
    }
  }

  isBlockedByCoin() {
    return this.cryptoSymbol === COIN_TICKER.NUARS;
  }

  changeCurrentCurrency(currency: CURRENCY_FILTER) {
    this.isChangeCurrency = true;
    if (!this.isBlockedByCoin()) {
      this.loading = true;
      this.cryptoService.currentCurrency = currency;
      this.isArsCurrency = this.cryptoService.currentCurrency === CURRENCY_FILTER.ARS;
      this.getCrypto();
    }
  }

  isViewChartMobile() {
    this.viewChartMobile = !this.viewChartMobile;
  }
}
